import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import type { ActivityDto } from './buildingBlock'
import { useDebounceFn } from '@vueuse/core'
import { DEFAULT_DEBOUNCE_DELAY } from '@/utils/debounce'

const serviceURL = API.BUILDING_BLOCK.ACTIVITIES.INDEX

export const useActivityStore = defineStore('activity', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<ActivityDto>({ service: serviceURL, api })

  return baseStore
})

export const debouncedStoreUpdate = useDebounceFn((activity: ActivityDto) => {
  if (!activity || activity.id == null) return
  const activityStore = useActivityStore()
  activityStore.update(activity)
}, DEFAULT_DEBOUNCE_DELAY)
